import React from "react";
import { Helmet } from "react-helmet";

const Head = ({ ...props }) => {
  return (
    <Helmet>
      <title>{props.title ? props.title + " | " : null} Ayurvedic Wellness Center- Ayurvedic Medicine & Treatment | Admin</title>
    </Helmet>
  );
};
export default Head;
